import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Home, Receipt, ShoppingCart, User } from 'lucide-react';
import { useApp } from '../context/AppContext';

/**
 * Sticky bottom tab-bar for mobile (<md:) screens. Hidden on desktop.
 * Hidden entirely on auth pages, the admin portal, vendor-admin portal,
 * and driver portal — those have their own navigation.
 */
const HIDDEN_PREFIXES = ['/login', '/signup', '/auth/', '/admin', '/vendor-admin', '/driver'];

const TABS = [
  { to: '/', label: 'Home', icon: Home, end: true },
  { to: '/orders', label: 'Orders', icon: Receipt },
  { to: '/cart', label: 'Cart', icon: ShoppingCart, showCartBadge: true },
  { to: '/profile', label: 'Me', icon: User },
];

const MobileBottomNav = () => {
  const loc = useLocation();
  const { cartCount } = useApp();
  if (HIDDEN_PREFIXES.some((p) => loc.pathname === p || loc.pathname.startsWith(p + '/') || (p.endsWith('/') && loc.pathname.startsWith(p)))) {
    return null;
  }
  return (
    <>
      <nav
        data-testid="mobile-bottom-nav"
        className="md:hidden fixed bottom-0 inset-x-0 z-30 bg-white/95 backdrop-blur border-t border-slate-200 pb-[max(env(safe-area-inset-bottom),0px)] shadow-[0_-1px_8px_rgba(15,23,42,0.04)]"
      >
        <div className="grid grid-cols-4 h-14">
          {TABS.map((t) => {
            const Icon = t.icon;
            return (
              <NavLink
                key={t.to}
                to={t.to}
                end={t.end}
                data-testid={`mobile-tab-${t.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `relative flex flex-col items-center justify-center gap-0.5 text-[10.5px] font-medium transition-colors ${
                    isActive ? 'text-emerald-700' : 'text-slate-500 hover:text-slate-800'
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    <span className="relative">
                      <Icon className="h-5 w-5" strokeWidth={isActive ? 2.4 : 2} />
                      {t.showCartBadge && cartCount > 0 && (
                        <span className="absolute -top-1.5 -right-2.5 min-w-[18px] h-[18px] px-1 rounded-full bg-orange-500 text-white text-[10px] font-semibold flex items-center justify-center" data-testid="mobile-cart-badge">
                          {cartCount}
                        </span>
                      )}
                    </span>
                    <span>{t.label}</span>
                    {isActive && <span className="absolute top-0 inset-x-6 h-0.5 rounded-b bg-emerald-600" />}
                  </>
                )}
              </NavLink>
            );
          })}
        </div>
      </nav>
      {/* Spacer so the last page row isn't covered by the fixed bar on mobile */}
      <div className="md:hidden h-16" aria-hidden="true" />
    </>
  );
};

export default MobileBottomNav;
